module.exports = __webpack_public_path__ + "img/logo.a75813e3.png";